<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <div class="mt-3 row" style="row-gap: 34px">
          <div v-for="module in moduleList" :key="module.id" class="col-3 text-center">
            <a target="_blank"
               @click="downloadFile(`/portal/private-coaching/module-details/${coachingData.id}/${module.id}`)">
              <img src="../../../../../assets/img/pdf_icon_version4.png"
                   style="width: 40px; height: 40px; margin-right: 20px; cursor: pointer" alt=""/>
            </a>
            <div class="mt-2">{{ module.name }}</div>
          </div>
        </div>

      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalPrivateCoachingService from '@/api/Portal/PrivateCoaching';
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import { downloadFile } from '@/shared/functions';
import { piniaUserStore } from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/PrivateCoaching/CoachingOverviewData.vue';
import Menu from '@/views/App/Portal/PrivateCoaching/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState?.currentUser?.user);
const route            = useRoute();
const coachingData     = ref('');
const coachingId       = +route.params.id;
const isLoaded         = ref(false);
const moduleList       = ref([]);

async function getCoachingData() {
  try {
    CloseToast();
    const { data } = await privateCoachingService.getPrivateCoaching(+coachingId);

    coachingData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getModuleList() {
  try {
    const { data }   = await portalPrivateCoachingService.getModuleList(coachingId);
    moduleList.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    getCoachingData(),
    getModuleList(),
  ]);
  isLoaded.value = true;
});
</script>

<style scoped>

</style>